// 域名云控：/workai/index/config 下发的 domain.api / domain.track_log 作为业务接口与埋点日志的域名。
//
// 先有鸡先有蛋：配置本身也要发请求才能拿到。配置接口的域名固定为 VITE_API_BASE_URL，
// 不参与云控（见 http.ts 的 configInstance）；env 里这两个值只作为下发前 / 下发失败时的兜底。
//
// 开发环境例外：VITE_API_BASE_URL / VITE_LOG_BASE_URL 都是空串，接口走 vite 代理；
// 一旦换成后端下发的绝对域名会直接跨域失败，所以 dev 下只打印不应用。
import { IS_DEV } from '@/constants/env';

let apiBase = import.meta.env.VITE_API_BASE_URL;
let logBase = import.meta.env.VITE_LOG_BASE_URL;

let resolveReady: () => void;
// 域名确定前发出的请求在这里排队，避免打到错误的域名上
const readyPromise = new Promise<void>((resolve) => {
    resolveReady = resolve;
});
let isReady = false;

// 业务接口域名
export function getApiBase() {
    return apiBase;
}

// 埋点日志域名
export function getLogBase() {
    return logBase;
}

// 请求发出前等待域名确定
export function whenDomainReady() {
    return readyPromise;
}

// 应用后端下发的域名。生效与否都不放行，由调用方统一 markDomainReady()。
export function applyRemoteDomain(domain: any) {
    if (IS_DEV) {
        console.log('[域名云控] 开发环境走 vite 代理，忽略后端下发 =>', domain);
        return;
    }

    if (domain?.api) apiBase = domain.api;
    if (domain?.track_log) logBase = domain.track_log;
    console.log('[域名云控] 已生效 =>', { apiBase, logBase });
}

// 放行排队中的请求。拉配置失败也必须调用，否则所有请求会一直挂起。
export function markDomainReady() {
    if (isReady) return;
    isReady = true;
    resolveReady();
}
